import clx from "classnames";
import { useNavigate } from "react-router-dom";
import AppButton from "./AppButton";
export default function CrudButtons({
  onSubmit = () => {},
  onCancell,
  removable = false,
  onRemove,
  removeLoading,
  removeTitle = "T.REMOVE",
  loading = false,
  disabled = false,
  title = "T.SAVE",
  className = "justify-between w-full",
}) {
  const navigate = useNavigate();
  return (
    <div className={clx("flex items-center space-x-2", className)}>
      <div className="flex items-center space-x-2">
        <AppButton onClick={() => (onCancell ? onCancell() : navigate(-1))} title="T.CANCEL" />
        {onRemove && removable && <AppButton mode="light-danger" title={removeTitle} loading={removeLoading} onClick={onRemove} />}
      </div>
      <AppButton mode="primary" title={title} loading={loading} disabled={disabled} onClick={onSubmit} />
    </div>
  );
}
